import { render, staticRenderFns } from "./Codeblock.vue?vue&type=template&id=481bf537&scoped=true"
import script from "./Codeblock.vue?vue&type=script&lang=js"
export * from "./Codeblock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bf537",
  null
  
)

export default component.exports